import React from 'react';
import { twMerge } from 'tailwind-merge';

interface DividerProps {
  className?: string;
  orientation: 'vertical' | 'horizontal';
}

const Divider: React.FC<DividerProps> = (props) => {
  const { className, orientation } = props;

  const dividerClassNames = twMerge(
    'border-[#E7E6E8]',
    className,
    orientation === 'horizontal' && 'border-t',
    orientation === 'vertical' && 'border-l',
  );

  return <div className={dividerClassNames} />;
};

export default Divider;
